import React, {Component} from 'react';
import {
  DropdownButton,
  MenuItem,
  Grid,
  Row,
  Col,
  Thumbnail,
  Button,
  FormGroup,
  ControlLabel,
  Pager,
  FormControl
} from "react-bootstrap"
// Load the localization from global scope
let text = window.text

// A Step implements a wrapper to display a mark-up wrapper for a step
// in the app.
const Step = ({current, user, number, title, children, final, login, move, error, logout, nextEnabled = true}) => {

  if(current != number)
    return null
  return (
    <div>
      <div className="menu-container">
        <Grid>
          <Row>
            <Col  xs={12} md={8}>
              <h3>
                <b>{text.step + number + ": "}</b>{title}
              </h3>
            </Col>
            <Col className="text-right" xs={12} md={4}>
              {!user? (<a className="login btn btn-light" onClick={login} >Login</a>) : (<a className="logout btn btn-light" onClick={logout}>Logout</a>)}
            </Col>
          </Row>
        </Grid>
      </div>
      <Grid className={"wrapper " + ("step" + number)}>
        <div className="area">
          {children}
        </div>
        <Pager className='holder'>
          {!final ? <Pager.Item next disabled={!nextEnabled} onClick={() => {
              if(error) {
                alert(text.errFixErrors)
              } else {
                move(false)
              }
          }
          }>{text.next}</Pager.Item> : null}
          {number != 1 ? <Pager.Item previous onClick={() => move(true)}>{text.prev}</Pager.Item> : null}
        </Pager>
      </Grid>
    </div>
  );
}


export default Step;



// WEBPACK FOOTER //
// ./Step.js